import type {PinPaymentSuccessData} from '../types';

import {Button, Divider} from '@ds/components';
import {PageLayout} from '@ds/layout';
import paymentSuccess from 'assets/images/pin-payment-success.svg';
import {useLocation, useNavigate} from 'react-router-dom';

import PinPackageGroups from '../components/common/PinPackageGroups/PinPackageGroups';
import {PIN_ROUTES} from '../constants';

const PinPaymentSuccess: React.FC = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const data = (state ?? {}) as PinPaymentSuccessData;

  return (
    <PageLayout
      footer={
        <Button fullWidth onClick={() => navigate(PIN_ROUTES.list)}>
          متوجه شدم
        </Button>
      }
    >
      <header className="flex min-h-87.5 flex-col items-center justify-center gap-2.5 p-2.5 text-center">
        <img src={paymentSuccess} alt="" aria-hidden />
        <h1 className="text-subtitle-lg text-neutral-fg">پرداخت با موفقیت انجام شد</h1>
        <p className="text-body-md text-gray-07">
          مبلغ قابل پرداخت در زمان تسویه در اولین موعد از فاکتور شما کسر می‌گردد.
        </p>
      </header>
      <Divider className="bg-gray-02" size={8} />
      <div className="p-2.5">
        <PinPackageGroups regions={data.items ?? []} mode="payment-success" />
      </div>
    </PageLayout>
  );
};

export default PinPaymentSuccess;
